export default __webpack_public_path__ + "static/media/iran_flag.cf86cbdf.png";